








import { openDB, DBSchema, IDBPDatabase } from "idb";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  DimssaButton,
  ButtonState
} from "@/components/shared/dimssa-button.vue";

@Component({
  components: { DimssaButton }
})
export default class Outbox extends Vue {
  numUnsent: number = 0;

  getNumUnsent() {
    openDB("workbox-background-sync", 1).then(db => {
      db.count("requests")
        .then(val => {
					//console.log("count: " + val);
					this.numUnsent = val;
        })
        .catch(error => {
					//console.log("object store 'requests' not found");
					this.numUnsent = 0;
        });
    });
	}

	onClickResend() {
		//navigator.serviceWorker.controller.postMessage('replayRequests');
	}

  mounted() {
    this.getNumUnsent();
  }
}
